import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M11.25 4h-3.2c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3.25 6.28 3.25 7.12 3.25 8.8v7.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.53 21 6.37 21 8.05 21h7.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311c.327-.642.327-1.482.327-3.162V13m-7 4h-6m8-4h-8m13.121-9.121A3 3 0 1 1 16.13 8.12 3 3 0 0 1 20.37 3.88"
    }, null, -1)
  ])))
}
export default { render: render }